import { PaginateQuery } from "core/resources/types/shared";
import { TempArquivo } from "core/features/arquivo/typings";

export interface VotacaoItem {
  id: string;
  nome: string;
  dataInicio: string;
  horaInicio: string;
  dataFim: string;
  horaFim: string;
  ambienteVotacaoId: string | null;
  tipoVotacaoId: string;
  webinarJoinUrl: string;
  numeroProcuracoes: {
    analise: number;
    pendente: number;
  };
  ativo: boolean;
}

export interface VotacaoPerguntaDto {
  id: string;
  titulo: string;
  ativo: boolean;
  dataEncerramento: string | null;
  ordem: number;
}

export interface VotacaoDetalhes extends VotacaoItem {
  webinarId: string;
  webinarSenha: string;
  webinarJoinUrl: string;
  webinarAovivo: boolean;
  perguntas: VotacaoPerguntaDto[];
  horaCheckin: string;
}

export interface VotacaoForm {
  nome: string;
  ambienteVotacaoId: string | null;
  webinarJoinUrl: string;
  tipoVotacaoId: string;
  dataInicio: string;
  dataFim: string;
  horaInicio: string;
  horaCheckin: string | null;
  horaFim: string;
  ativo: boolean;
  perguntas: VotacaoPerguntaForm[];
}

export interface VotacaoPerguntaOpcaoForm {
  titulo: string;
  ordem: number;
}

export interface VotacaoPerguntaForm {
  titulo: string;
  ordem: number;
  multiplaResposta: boolean;
  numeroMaximoResposta: number;
  mostrarParcial: boolean;
  habilitarComentario: boolean;
  dataEncerramento: string | null;
  ativo: boolean;
  opcoes: VotacaoPerguntaOpcaoForm[];
  videoId?: string;
  arquivoId?: string;
  video?: TempArquivo | null;
  arquivo?: TempArquivo | null;
}

export interface VotacaoDashboardDto {
  totalParticipantes: number;
  jaVotaram: number;
  aindaNaoVotaram: number;
  totalPesos: number;
}

export interface VotacaoPerguntaEstatisticaDetalhesDto {
  id: string;
  participantes: number;
  totalPesos: number;
  total: number;
  totalNaoVotaram: number;
  opcoes: {
    id: string;
    titulo: string;
    ordem: number;
    votos: number;
  }[];
}

export interface VotacaoParticipanteVotanteItem {
  // id: string;
  pessoa: { id: string; nome: string; imagemUrl: string };
  // data?: string;
}

export interface VotantesListagemQuery extends PaginateQuery {
  idAssembleia: string;
  idPergunta: string;
}

export interface ParametrosAssembleia {
  bloquearInadimplente: boolean;
  tipoIntervaloCheckin: string;
  antecedenciaCheckinintervaloCheckinQuantidade: number;
}

export interface VotacaoParticipanteItem {
  id: string;
  pessoa: { id: string; nome: string };
  unidades: {
    id: string;
    numero: string;
    peso: number;
    blocoQuadra: { id: string; nome: string } | null;
    inadimplente?: boolean;
  }[];
  peso: number;
  dataCheckin: string | null;
}

export enum TipoParticipante {
  Morador = "s",
  Visitante = "n",
}

export interface ParticipanteForm {
  tipoParticipante?: TipoParticipante;
  nome: string;
  dataNascimento: string;
  documento: string;
  celular: string;
  email: string;
  pessoaId: string;
  unidades: string[];
  ehMorador: boolean;
  realizarCheckin: boolean;
}

export interface VotacaoParticipanteResponse {
  id: string;
  nome: string;
  imagemUrl: string;
  documento: string;
  createdAt: string;
  unidades: { id: string; numero: string; blocoQuadra: string; peso: number }[];
  peso: number;
}

export interface UnidadeParticipanteItem {
  createdAt?: string;
  proprietario: string;
  unidade?: {
    numero: string;
    blocoQuadra?: string;
  };
  imagemUrl?: string | null;
}

export interface VotacaoVotoIndividualItem {
  id: string;
  pessoa: {
    id: string;
    nome: string;
    imagemUrl: string;
  };
  opcao: {
    id: string;
    titulo: string;
  };
  unidades: {
    id: string;
    numero: string;
    peso: number;
    blocoQuadra: {
      id: string;
      nome: string;
    } | null;
  }[];
  pesoTotal: number;
  dataVoto: string;
}

export interface VotacaoVotosPorOpcaoItem {
  opcao: {
    id: string;
    titulo: string;
    ordem: number;
  };
  votos: VotacaoVotoIndividualItem[];
  totalVotos: number;
  totalPeso: number;
}

export interface VotacaoVotosPorPerguntaItem {
  pergunta: {
    id: string;
    titulo: string;
    ordem: number;
  };
  opcoes: VotacaoVotosPorOpcaoItem[];
  totalVotos: number;
  totalPeso: number;
}
